import { render, staticRenderFns } from "./selfCheckInfo.vue?vue&type=template&id=3c5a225a&scoped=true&"
import script from "./selfCheckInfo.vue?vue&type=script&lang=js&"
export * from "./selfCheckInfo.vue?vue&type=script&lang=js&"
import style0 from "./selfCheckInfo.vue?vue&type=style&index=0&id=3c5a225a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a225a",
  null
  
)

export default component.exports